<div id="sub-breadcrumb" class="custom-breadcrumb border-none">
    <nav style="--bs-breadcrumb-divider: url(../../../../../assets/images/breadcrumb-divider.svg);" aria-label="breadcrumb">
        <ol class="breadcrumb">
          <ng-content></ng-content>
        </ol>
      </nav>
</div>